export type Language = 'en' | 'ar' | 'fr' | 'es' | 'ur';

export const translations = {
  en: {
    greeting: "As-salamu alaykum",
    day: "Day",
    journey: "on your roadmap to Jannah",
    focus: "Today's Focus",
    start: "Start Session",
    library: "The Gift of Speech",
    libraryDesc: "Learn the language of the believers",
    zakat: "Zakat Portal",
    zakatDesc: "Purify your wealth",
    lifeline: "Need a lifeline?",
    lifelineDesc: "Feeling overwhelmed or lost? Grab the rope. We are here.",
    support: "Get Support",
    zakatTitle: "Zakat Calculator",
    zakatDue: "Your Zakat Due (2.5%)",
    cash: "Cash & Bank Balances",
    gold: "Gold & Silver Value",
    stocks: "Stocks & Investments",
    debts: "Immediate Debts (Deductible)",
    calculate: "Calculate My Zakat",
    pay: "Pay My Zakat Now",
    purify: "Purify Your Wealth",
    zakatMsg: "Your Zakat due is",
    choose: "Choose where to send it directly.",
    recalculate: "Recalculate",
    home: "Return Home",
    policy: "We do not touch your money.",
    completed: "Completed"
  },
  ar: {
    greeting: "السلام عليكم",
    day: "اليوم",
    journey: "من رحلتك",
    focus: "تركيز اليوم",
    start: "ابدأ الجلسة",
    library: "نعمة البيان",
    libraryDesc: "تعلم لغة المؤمنين",
    zakat: "بوابة الزكاة",
    zakatDesc: "طهر مالك",
    lifeline: "تحتاج إلى مساعدة؟",
    lifelineDesc: "تشعر بالإرهاق أو الضياع؟ تمسك بالحبل. نحن هنا.",
    support: "احصل على الدعم",
    zakatTitle: "حاسبة الزكاة",
    zakatDue: "زكاتك المستحقة (2.5%)",
    cash: "النقد والأرصدة البنكية",
    gold: "قيمة الذهب والفضة",
    stocks: "الأسهم والاستثمارات",
    debts: "الديون الحالية (تخصم)",
    calculate: "احسب زكاتي",
    pay: "ادفع زكاتي الآن",
    purify: "طهر مالك",
    zakatMsg: "زكاتك المستحقة هي",
    choose: "اختر أين ترسلها مباشرة.",
    recalculate: "إعادة الحساب",
    home: "العودة للرئيسية",
    policy: "نحن لا نلمس أموالك.",
    completed: "مكتمل"
  },
  fr: {
    greeting: "As-salamu alaykum",
    day: "Jour",
    journey: "de votre voyage",
    focus: "Focus du Jour",
    start: "Commencer",
    library: "Le Don de la Parole",
    libraryDesc: "Apprenez la langue des croyants",
    zakat: "Portail Zakat",
    zakatDesc: "Purifiez votre richesse",
    lifeline: "Besoin d'aide ?",
    lifelineDesc: "Vous vous sentez perdu ? Saisissez la corde. Nous sommes là.",
    support: "Obtenir de l'aide",
    zakatTitle: "Calculateur de Zakat",
    zakatDue: "Votre Zakat Due (2.5%)",
    cash: "Argent & Soldes Bancaires",
    gold: "Valeur Or & Argent",
    stocks: "Actions & Investissements",
    debts: "Dettes Immédiates (Déductibles)",
    calculate: "Calculer ma Zakat",
    pay: "Payer ma Zakat Maintenant",
    purify: "Purifiez Votre Richesse",
    zakatMsg: "Votre Zakat due est de",
    choose: "Choisissez où l'envoyer directement.",
    recalculate: "Recalculer",
    home: "Retour Accueil",
    policy: "Nous ne touchons pas à votre argent.",
    completed: "Terminé"
  },
  es: {
    greeting: "As-salamu alaykum",
    day: "Día",
    journey: "de tu viaje",
    focus: "Enfoque de Hoy",
    start: "Iniciar Sesión",
    library: "El Don del Habla",
    libraryDesc: "Aprende el lenguaje de los creyentes",
    zakat: "Portal de Zakat",
    zakatDesc: "Purifica tu riqueza",
    lifeline: "¿Necesitas ayuda?",
    lifelineDesc: "¿Te sientes abrumado o perdido? Agarra la cuerda. Estamos aquí.",
    support: "Obtener Apoyo",
    zakatTitle: "Calculadora de Zakat",
    zakatDue: "Tu Zakat Adecuado (2.5%)",
    cash: "Efectivo y Saldos Bancarios",
    gold: "Valor de Oro y Plata",
    stocks: "Acciones e Inversiones",
    debts: "Deudas Inmediatas (Deducibles)",
    calculate: "Calcular mi Zakat",
    pay: "Pagar mi Zakat Ahora",
    purify: "Purifica Tu Riqueza",
    zakatMsg: "Tu Zakat debido es",
    choose: "Elige dónde enviarlo directamente.",
    recalculate: "Recalcular",
    home: "Volver al Inicio",
    policy: "No tocamos tu dinero.",
    completed: "Completado"
  },
  ur: {
    greeting: "السلام عليكم",
    day: "دن",
    journey: "آپ کے سفر کا",
    focus: "آج کی توجہ",
    start: "شروع کریں",
    library: "گفتار کا تحفہ",
    libraryDesc: "مومنوں کی زبان سیکھیں",
    zakat: "زکوٰۃ پورٹل",
    zakatDesc: "اپنی دولت پاک کریں",
    lifeline: "مدد کی ضرورت ہے؟",
    lifelineDesc: "کیا آپ پریشان ہیں؟ رسی کو تھام لیں۔ ہم یہاں ہیں۔",
    support: "مدد حاصل کریں",
    zakatTitle: "زکوٰۃ کیلکولیٹر",
    zakatDue: "آپ کی واجب الادا زکوٰۃ (2.5%)",
    cash: "نقد اور بینک بیلنس",
    gold: "سونے اور چاندی کی قیمت",
    stocks: "اسٹاک اور سرمایہ کاری",
    debts: "فوری قرض (منہا)",
    calculate: "میری زکوٰۃ کا حساب لگائیں",
    pay: "اب زکوٰۃ ادا کریں",
    purify: "اپنی دولت پاک کریں",
    zakatMsg: "آپ کی واجب الادا زکوٰۃ ہے",
    choose: "منتخب کریں کہ اسے براہ راست کہاں بھیجنا ہے۔",
    recalculate: "دوبارہ حساب لگائیں",
    home: "واپس جائیں",
    policy: "ہم آپ کے پیسے کو نہیں چھوتے۔",
    completed: "مکمل"
  }
};
